import { render, staticRenderFns } from "./QualityFreeze.vue?vue&type=template&id=1f953983"
import script from "./QualityFreeze.vue?vue&type=script&lang=js"
export * from "./QualityFreeze.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports